module.exports = {

    init: function () {

        $('.menu-trigger').click(function () {
            $('header .menus').toggleClass('open');
            $(this).toggleClass('open');
        });

        $('.menu-item-has-children').click(function () {
            $(this).toggleClass('open');
        });

    }

};